import classNames from 'classnames';
import React from 'react';
import './index.scss';

export interface EfPictureProps {
    /**
     * src图片源
     */
    src: string;
    /**
     * srcMax图片源（>1920px）
     */
    srcMax?: string;
    /**
     * srcDesktop图片源（笔记本端）
     */
    srcDesktop?: string;
    /**
     * srcPad图片源（Pad端）
     */
    srcPad?: string;
    /**
     * srcMobile图片源（M端 手机）
     */
    srcMobile?: string;
    /**
     * alt 图片显示失败提示语
     */
    alt?: string;
    /**
     * className
     */
    className?: string;
}

/**
 * 维护: kalkin
 *
 * 图片组件（基于html img标签）
 * html内容 不是css修饰。
 * 1. 1, 利于语义化、SEO搜索
 * 2. 2, 利于图片自身宽高比自定义或自适应
 * 3. 3, 先加载DOM树后加载css样式，所以图片比较大时可能造成HTML渲染堵塞（大图建议使用ef-img)
 * 4. 4, img支持网页打印、同时可以右键下载保存
 * 5. 5, 支持多媒体查询，适用多种分辨率
 */
const EFPicture: React.FC<EfPictureProps> = ({ src, srcMax = '', srcDesktop = '', srcPad = '', srcMobile = '', alt = 'EF-Picture', className }) => {
    const prefixCls = `ef-picture`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });

    return (
        <div className={classes}>
            <picture className="picture">
                {srcMobile && <source media={`(max-width: 767px)`} srcSet={srcMobile} />}
                {srcPad && <source media={`(max-width: 1024px)`} srcSet={srcPad} />}
                {srcDesktop && <source media={`(max-width: 1440px)`} srcSet={srcDesktop} />}
                {srcMax && <source media={`(min-width: 1921px)`} srcSet={srcMax} />}
                <img className="picture-img" src={src} alt={alt || 'EF-Picture'} aria-label={alt || 'EF-Picture'} />
            </picture>
        </div>
    );
};

export default EFPicture;
